import { ReactNode } from 'react';

import { Flex } from '@atlaskit/primitives';

export const FilterContainer = ({ children }: { children: ReactNode }) => (
  <Flex gap="space.100">{children}</Flex>
);
